const HttpStatus = {
    // 成功的状态码
    SUCCESS: "200",             // OK
    CREATED: "201",             // Created
    ACCEPTED: "202",            // Accepted
    NO_CONTENT: "204",          // No Content

    // 客户端错误状态码
    BAD_REQUEST: "400",         // Bad Request
    UNAUTHORIZED: "401",        // Unauthorized
    FORBIDDEN: "403",           // Forbidden
    NOT_FOUND: "404",           // Not Found
    METHOD_NOT_ALLOWED: "405",  // Method Not Allowed

    // 服务器错误状态码
    INTERNAL_SERVER_ERROR: "500", // Internal Server Error
    NOT_IMPLEMENTED: "501",       // Not Implemented
    BAD_GATEWAY: "502",           // Bad Gateway
    SERVICE_UNAVAILABLE: "503",   // Service Unavailable
    GATEWAY_TIMEOUT: "504",       // Gateway Timeout

    // 自定义的错误状态码（根据实际需求扩展）
    ERROR: "520",                 // General Error
    DATABASE_ERROR: "521",        // Database Error
};

export default HttpStatus;
